/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/admin_ai_search/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Execute an Azure AI Search query directly from the admin portal.
         * @description This endpoint allows admins to test search queries and see raw results.
         */
        post: operations["post_admin_ai_search"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/chat-messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get chat messages analytics data. */
        get: operations["get_get_chat_messages_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/conversations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get conversations analytics data. */
        get: operations["get_get_conversations_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/feedback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get feedback analytics data. */
        get: operations["get_get_feedback_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/peak-hours": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get peak hours analytics from conversation history. */
        get: operations["get_get_peak_hours_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/touchpoints": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get touchpoint analytics data. */
        get: operations["get_get_touchpoint_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/analytics/user-activity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get user activity analytics data. */
        get: operations["get_get_user_activity_analytics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/auth_setup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_auth_setup"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/authorization": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_authorization"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_config"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/content/{path}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Serve content files from blob storage from within the app to keep the example self-contained.
         * @description *** NOTE *** if you are using app services authentication, this route will return unauthorized to all users that are not logged in
         *     This is also slow and memory hungry.
         */
        get: operations["get_content_file"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feedback/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_export_feedback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feedback/{feedback_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_feedback_item"];
        put?: never;
        post?: never;
        /**
         * Hard-delete a feedback item: its Databricks traces, its underlying chat history
         * @description conversation, and every other feedback document on that same conversation (see
         *     `helpers.admin_deletion.hard_delete_conversation`).
         */
        delete: operations["delete_delete_feedback_item"];
        options?: never;
        head?: never;
        patch: operations["patch_patch_feedback_item"];
        trace?: never;
    };
    "/feedbacklist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_feedback"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/history/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_export_history"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/history/items/{item_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_chat_history_item_admin"];
        put?: never;
        post?: never;
        /**
         * Hard-delete a conversation: its Databricks traces, its chat history document, and every
         * @description feedback document that references it (see `helpers.admin_deletion.hard_delete_conversation`).
         *
         *     `item_id` (the conversation id) can be client-supplied and so is not guaranteed unique
         *     across users; the caller must also supply the `entra_oid` query param - the owner the admin
         *     UI displayed for this conversation (from `get_chat_history_item_admin`) - so the deletion is
         *     scoped to that specific user's partition rather than matching whichever user's document
         *     happens to share this id.
         */
        delete: operations["delete_delete_history_item_admin"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/history/items/{item_id}/databricks-trace-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Look up a Databricks UI deep link to this conversation's traces on demand, so the
         * @description admin UI can redirect to it without needing to know how Databricks trace URLs are
         *     constructed or whether Databricks tracing is even enabled.
         */
        get: operations["get_get_history_item_databricks_trace_url"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/history/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_history"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/idea/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_export_ideas"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/idea/{idea_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_idea"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: operations["patch_patch_idea"];
        trace?: never;
    };
    "/idealist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_ideas"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/speech": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_speech"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_export_users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_users_list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_user_details"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{user_id}/settings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["put_update_user_settings_admin"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/usersettings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_get_user_settings"];
        put?: never;
        post: operations["post_update_user_settings"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/chat/feedback/{conversation_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_v2_chat_feedback"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/chat/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_v2_chat_history_list"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/chat/history/{conversation_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_v2_chat_history_detail"];
        delete: operations["delete_v2_delete_chat_history"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/chat/stream": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_v2_chat_stream"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/chat/userfilter": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_v2_user_filter_options"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/examplequestion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_v2_example_questions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/sst/transcribe": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["post_sst_transcribe"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v2/sst/wss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Speech-to-text (WebSocket)
         * @description The client streams the recording as binary PCM16 messages and sends SttClientFrame JSON frames; it receives SttServerFrame JSON frames.
         */
        get: {
            parameters: {
                query?: {
                    /** @description Bearer token, for clients that can't set handshake headers (browsers). */
                    token?: string;
                    /** @description Sample rate of the PCM16 audio in Hz. */
                    sampleRate?: number;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description Switching to the WebSocket protocol. */
                101: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Unsupported handshake parameters. */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Missing or invalid token. */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not configured. */
                503: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/version": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["get_version"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * AdminChatHistoryItem
         * @description A conversation as the admin history viewer sees it.
         */
        AdminChatHistoryItem: {
            /** Answers */
            answers: components["schemas"]["AdminChatHistoryTurn"][];
            /** Email */
            email: string;
            /** Entra Oid */
            entra_oid: string;
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Timestamp */
            timestamp: number;
            /** Title */
            title: string;
            /** Username */
            username: string;
        };
        /** AdminChatHistoryTurn */
        AdminChatHistoryTurn: {
            /**
             * Complaintdetected
             * @default null
             */
            complaintDetected: boolean | null;
            /** @default human */
            domain: components["schemas"]["Domain"];
            response: components["schemas"]["Delta"];
            /** Sstrequestids */
            sstRequestIds: string[];
            /** Usermessage */
            userMessage: string;
        };
        /** AppConfig */
        AppConfig: {
            /** Environment */
            environment: string;
            /** Googletagmanagerid */
            googleTagManagerId: string | null;
            /** Showchathistorybrowser */
            showChatHistoryBrowser: boolean;
            /** Showchathistorycosmos */
            showChatHistoryCosmos: boolean;
            /** Showspeechoutputazure */
            showSpeechOutputAzure: boolean;
            /** Showspeechoutputbrowser */
            showSpeechOutputBrowser: boolean;
        };
        /** AssetTypeOption */
        AssetTypeOption: {
            /**
             * Group
             * @default null
             */
            group: string | null;
            /** Id */
            id: string;
            /** Name */
            name: string;
        };
        /**
         * AuthSetup
         * @description MSAL.js settings for the client app.
         */
        AuthSetup: {
            /** Enableunauthenticatedaccess */
            enableUnauthenticatedAccess: boolean;
            loginRequest: components["schemas"]["MsalRequest"];
            msalConfig: components["schemas"]["MsalConfig"];
            tokenRequest: components["schemas"]["MsalRequest"];
            /** Uselogin */
            useLogin: boolean;
        };
        /** Authorization */
        Authorization: {
            /** Isadmin */
            isAdmin: boolean;
        };
        /** BuildInfo */
        BuildInfo: {
            /**
             * Branch
             * @default null
             */
            branch: string | null;
            /** Buildtime */
            buildTime: string;
            /** Environment */
            environment: string;
            /** Githash */
            gitHash: string;
        };
        /** ChatFeedbackRequest */
        ChatFeedbackRequest: {
            /**
             * Comment
             * @default null
             */
            comment?: string | null;
            /** Positive */
            positive: boolean;
            /** @default null */
            reason?: components["schemas"]["FeedbackReason"] | null;
            /** Turnindex */
            turnIndex: number;
        };
        /** ChatHistory */
        ChatHistory: {
            /** Continuationtoken */
            continuationToken: string | null;
            /** Items */
            items: components["schemas"]["ChatHistoryItem"][];
        };
        /** ChatHistoryItem */
        ChatHistoryItem: {
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: number;
            /** Title */
            title: string;
        };
        /** ChatHistoryItemDetails */
        ChatHistoryItemDetails: {
            /** Answers */
            answers: components["schemas"]["ChatHistoryTurn"][];
            /** Id */
            id: string;
            /** Timestamp */
            timestamp: number;
            /** Title */
            title: string;
        };
        /** ChatHistoryRequest */
        ChatHistoryRequest: {
            /**
             * Continuationtoken
             * @default null
             */
            continuationToken?: string | null;
            /** Count */
            count: number;
            /** @default null */
            domain?: components["schemas"]["Domain"] | null;
        };
        /** ChatHistoryTurn */
        ChatHistoryTurn: {
            /**
             * Complaintdetected
             * @default null
             */
            complaintDetected: boolean | null;
            /** @default human */
            domain: components["schemas"]["Domain"];
            response: components["schemas"]["Delta"];
            /** Usermessage */
            userMessage: string;
        };
        /** ChatMessageAnalyticsResponseSchema */
        ChatMessageAnalyticsResponseSchema: {
            /** Aggregation */
            aggregation: string;
            /**
             * Available Countries
             * @default null
             */
            available_countries?: string[] | null;
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /**
             * Available Touchpoints
             * @default null
             */
            available_touchpoints?: string[] | null;
            /** Data */
            data: components["schemas"]["ChatMessageDataPoint"][];
            /** End Date */
            end_date: string;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Total Items */
            total_items: number;
        };
        /** ChatMessageDataPoint */
        ChatMessageDataPoint: {
            /** Average */
            average: number;
            /** Date Key */
            date_key: string;
            /** Name */
            name: string;
            /** Total Conversations */
            total_conversations: number;
            /** Total Messages */
            total_messages: number;
        };
        /** ChatRequest */
        ChatRequest: {
            /**
             * Datasources
             * @default null
             */
            dataSources?: string[] | null;
            /** @default human */
            domain?: components["schemas"]["Domain"];
            /**
             * Id
             * @default null
             */
            id?: string | null;
            /** Message */
            message: string;
            /** Selectedcountries */
            selectedCountries: string[];
            /** Sstrequestids */
            sstRequestIds?: string[];
            /** @default null */
            userFilters?: components["schemas"]["UserFilter"] | null;
        };
        /** ConversationAnalyticsResponseSchema */
        ConversationAnalyticsResponseSchema: {
            /** Aggregation */
            aggregation: string;
            /**
             * Available Countries
             * @default null
             */
            available_countries?: string[] | null;
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /**
             * Available Touchpoints
             * @default null
             */
            available_touchpoints?: string[] | null;
            /** Data */
            data: components["schemas"]["ConversationDataPoint"][];
            /** End Date */
            end_date: string;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Total Items */
            total_items: number;
            /** Total Messages */
            total_messages: number;
            /** Total Unique Users */
            total_unique_users: number;
        };
        /** ConversationDataPoint */
        ConversationDataPoint: {
            /** Date Key */
            date_key: string;
            /** Messages */
            messages: number;
            /** Name */
            name: string;
            /** Total */
            total: number;
            /** Unique Users */
            unique_users: number;
        };
        /** DatabricksTraceUrl */
        DatabricksTraceUrl: {
            /** Url */
            url: string;
        };
        /** Delta */
        Delta: {
            /**
             * Error
             * @default null
             */
            error?: string | null;
            /** @default null */
            errorDetails?: components["schemas"]["ErrorDetails"] | null;
            /**
             * Followupquestions
             * @default null
             */
            followUpQuestions?: string[] | null;
            /**
             * Id
             * @default null
             */
            id?: string | null;
            /**
             * Phidetected
             * @default null
             */
            phiDetected?: boolean | null;
            /**
             * Response
             * @default null
             */
            response?: string | null;
            /**
             * Role
             * @default assistant
             */
            role?: string;
            /**
             * Sources
             * @default null
             */
            sources?: components["schemas"]["Source"][] | null;
            /**
             * Thoughts
             * @default null
             */
            thoughts?: components["schemas"]["Thought"][] | null;
            /**
             * Toolcalls
             * @default null
             */
            toolCalls?: components["schemas"]["ToolCall"][] | null;
        };
        /** @enum {string} */
        Domain: "human" | "vet";
        /** ErrorDetails */
        ErrorDetails: {
            /**
             * Code
             * @enum {string}
             */
            code: "rate_limit" | "content_filter" | "content_length" | "generic";
        };
        /** ExampleQuestion */
        ExampleQuestion: {
            /** Question */
            question: string;
        };
        /** ExampleQuestions */
        ExampleQuestions: {
            /** Questions */
            questions: components["schemas"]["ExampleQuestion"][];
        };
        /** @enum {string} */
        FailureType:
            | "Hallucination"
            | "Incorrect answer"
            | "Incomplete answer"
            | "No answer"
            | "Question issue"
            | "Technical issue"
            | "Policy issue"
            | "Source issue"
            | "Other";
        /** FeedbackAnalyticsResponseSchema */
        FeedbackAnalyticsResponseSchema: {
            /** Aggregation */
            aggregation: string;
            /**
             * Available Countries
             * @default null
             */
            available_countries?: string[] | null;
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /**
             * Available Touchpoints
             * @default null
             */
            available_touchpoints?: string[] | null;
            /** Data */
            data: components["schemas"]["FeedbackDataPoint"][];
            /** End Date */
            end_date: string;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Total Items */
            total_items: number;
        };
        /** FeedbackDataPoint */
        FeedbackDataPoint: {
            /** Date Key */
            date_key: string;
            /** Name */
            name: string;
            /** Negative */
            negative: number;
            /** Positive */
            positive: number;
        };
        /**
         * FeedbackItem
         * @description A single feedback document, with its conversation snapshot sanitized.
         */
        FeedbackItem: {
            /** Answers */
            answers: components["schemas"]["AdminChatHistoryTurn"][];
            /**
             * Comment
             * @default null
             */
            comment: string | null;
            /**
             * Conversation Id
             * @default null
             */
            conversation_id: string | null;
            /**
             * Email
             * @default null
             */
            email: string | null;
            /** Entra Oid */
            entra_oid: string;
            /** @default null */
            failure_type: components["schemas"]["FailureType"] | null;
            /** Id */
            id: string;
            /**
             * Jira Ticket
             * @default null
             */
            jira_ticket: string | null;
            /**
             * Name
             * @default null
             */
            name: string | null;
            /**
             * Positive
             * @default null
             */
            positive: boolean | null;
            /** @default null */
            reason: components["schemas"]["FeedbackReason"] | null;
            /**
             * Review Status
             * @default null
             */
            review_status: "reviewed" | null;
            /** Timestamp */
            timestamp: number;
            /**
             * Turn Index
             * @default null
             */
            turn_index: number | null;
            /**
             * User Country
             * @default null
             */
            user_country: string | null;
            /**
             * Username
             * @default null
             */
            username: string | null;
        };
        /** FeedbackList */
        FeedbackList: {
            /** Feedback */
            feedback: components["schemas"]["FeedbackListItem"][];
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Items */
            total_items: number;
            /** Total Pages */
            total_pages: number;
        };
        /**
         * FeedbackListItem
         * @description A row of the admin feedback list, as projected by the list query.
         */
        FeedbackListItem: {
            domain: components["schemas"]["Domain"];
            /** @default null */
            failure_type: components["schemas"]["FailureType"] | null;
            /** Feedback Target */
            feedback_target: string;
            /**
             * Feedback Text
             * @default null
             */
            feedback_text: string | null;
            /**
             * Feedback Type
             * @enum {string}
             */
            feedback_type: "like" | "dislike";
            /** Id */
            id: string;
            /**
             * Name
             * @default null
             */
            name: string | null;
            /** @default null */
            reason: components["schemas"]["FeedbackReason"] | null;
            /**
             * Review Status
             * @default null
             */
            review_status: "reviewed" | null;
            /** Timestamp */
            timestamp: number;
            /**
             * User Country
             * @default null
             */
            user_country: string | null;
            /**
             * Username
             * @default null
             */
            username: string | null;
        };
        /** @enum {string} */
        FeedbackReason: "incorrect_answer" | "incomplete_answer" | "unsuitable_asset";
        /** FilterOptions */
        FilterOptions: {
            /** Assettypes */
            assetTypes: components["schemas"]["AssetTypeOption"][];
            /** Interestareas */
            interestAreas: components["schemas"]["InterestAreaOption"][];
        };
        /** HistoryList */
        HistoryList: {
            /** History */
            history: components["schemas"]["HistoryListItem"][];
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Items */
            total_items: number;
            /** Total Pages */
            total_pages: number;
        };
        /**
         * HistoryListItem
         * @description A row of the admin history list, as projected by the list query.
         */
        HistoryListItem: {
            domain: components["schemas"]["Domain"];
            /** Id */
            id: string;
            /**
             * Messages Count
             * @default null
             */
            messages_count: number | null;
            /**
             * Name
             * @default null
             */
            name: string | null;
            /** Timestamp */
            timestamp: number;
            /**
             * Title
             * @default null
             */
            title: string | null;
            /**
             * User Country
             * @default null
             */
            user_country: string | null;
            /**
             * Username
             * @default null
             */
            username: string | null;
        };
        /**
         * IdeaItem
         * @description An idea as the admin UI sees it, in the list and in the detail view.
         */
        IdeaItem: {
            /**
             * Category
             * @default null
             */
            category: string | null;
            /**
             * Conversation Id
             * @default null
             */
            conversation_id: string | null;
            /** Entra Oid */
            entra_oid: string;
            /** Id */
            id: string;
            /**
             * Idea
             * @default null
             */
            idea: string | null;
            /**
             * Jira Link
             * @default null
             */
            jira_link: string | null;
            /**
             * Name
             * @default null
             */
            name: string | null;
            /**
             * Review Comment
             * @default null
             */
            review_comment: string | null;
            /** @default null */
            review_status: components["schemas"]["IdeaReviewStatus"] | null;
            /**
             * Status
             * @enum {string}
             */
            status: "draft" | "confirmed";
            /** Timestamp */
            timestamp: number;
            /**
             * Username
             * @default null
             */
            username: string | null;
        };
        /** IdeaList */
        IdeaList: {
            /** Ideas */
            ideas: components["schemas"]["IdeaItem"][];
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Items */
            total_items: number;
            /** Total Pages */
            total_pages: number;
        };
        /** @enum {string} */
        IdeaReviewStatus: "new" | "reviewed" | "cancelled";
        /** InterestAreaOption */
        InterestAreaOption: {
            /** Key */
            key: string;
            /** Name */
            name: string;
        };
        /** MsalAuthConfig */
        MsalAuthConfig: {
            /** Authority */
            authority: string;
            /** Clientid */
            clientId: string | null;
            /** Navigatetologinrequesturl */
            navigateToLoginRequestUrl: boolean;
            /** Postlogoutredirecturi */
            postLogoutRedirectUri: string;
            /** Redirecturi */
            redirectUri: string;
        };
        /** MsalCacheConfig */
        MsalCacheConfig: {
            /** Cachelocation */
            cacheLocation: string;
            /** Storeauthstateincookie */
            storeAuthStateInCookie: boolean;
        };
        /** MsalConfig */
        MsalConfig: {
            auth: components["schemas"]["MsalAuthConfig"];
            cache: components["schemas"]["MsalCacheConfig"];
        };
        /** MsalRequest */
        MsalRequest: {
            /** Scopes */
            scopes: string[];
        };
        /** PatchFeedbackRequest */
        PatchFeedbackRequest: {
            /**
             * Comment
             * @default null
             */
            comment?: string | null;
            /** @default null */
            failure_type?: components["schemas"]["FailureType"] | null;
            /**
             * Jira Ticket
             * @default null
             */
            jira_ticket?: string | null;
            /**
             * Review Status
             * @default null
             */
            review_status?: "reviewed" | null;
        };
        /** PatchIdeaRequest */
        PatchIdeaRequest: {
            /**
             * Jira Link
             * @default null
             */
            jira_link?: string | null;
            /**
             * Review Comment
             * @default null
             */
            review_comment?: string | null;
            /** @default null */
            review_status?: components["schemas"]["IdeaReviewStatus"] | null;
        };
        /** PeakHoursAnalyticsResponseSchema */
        PeakHoursAnalyticsResponseSchema: {
            /** Available Countries */
            available_countries: string[];
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /**
             * Available Touchpoints
             * @default null
             */
            available_touchpoints?: string[] | null;
            /** Data */
            data: components["schemas"]["PeakHoursDataPoint"][];
            /** End Date */
            end_date: string;
            /** Peak Hour */
            peak_hour: number;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Total Activities */
            total_activities: number;
        };
        /** PeakHoursDataPoint */
        PeakHoursDataPoint: {
            /** Activity Count */
            activity_count: number;
            /** Hour */
            hour: number;
            /** Percentage */
            percentage: number;
            /** Unique Users */
            unique_users: number;
        };
        /**
         * SearchAdminRequest
         * @description Body of POST /admin_ai_search/search. Documentation only: the route reads the
         *     fields itself, with these defaults.
         */
        SearchAdminRequest: {
            /** Asset Types */
            asset_types?: string[];
            /**
             * Cloudinary Id
             * @default
             */
            cloudinary_id?: string;
            /** Detected Interest Areas */
            detected_interest_areas?: string[];
            /** @default null */
            domain?: components["schemas"]["Domain"] | null;
            /** Interest Areas */
            interest_areas?: string[];
            /**
             * Minimum Reranker Score
             * @default null
             */
            minimum_reranker_score?: number | null;
            /**
             * Minimum Search Score
             * @default null
             */
            minimum_search_score?: number | null;
            /** Overrides */
            overrides?: {
                [key: string]: unknown;
            };
            /**
             * Query Text
             * @default
             */
            query_text?: string;
            /**
             * Reference Number
             * @default
             */
            reference_number?: string;
            /** Selected Countries */
            selected_countries?: string[];
            /**
             * Source File
             * @default
             */
            source_file?: string;
            /** Sources */
            sources?: string[];
            /**
             * Top
             * @default 5
             */
            top?: number;
            /**
             * Use Query Rewriting
             * @default false
             */
            use_query_rewriting?: boolean;
            /**
             * Use Semantic Captions
             * @default false
             */
            use_semantic_captions?: boolean;
            /**
             * Use Semantic Ranker
             * @default true
             */
            use_semantic_ranker?: boolean;
            /**
             * Use Text Search
             * @default true
             */
            use_text_search?: boolean;
            /**
             * Use Vector Search
             * @default true
             */
            use_vector_search?: boolean;
        };
        /** SearchAdminResponse */
        SearchAdminResponse: {
            /** Filter */
            filter: string;
            /** Query Text */
            query_text: string;
            /** Results */
            results: components["schemas"]["SearchResultDocument"][];
            search_parameters: components["schemas"]["SearchParameters"];
            /** Total Results */
            total_results: number;
        };
        /** SearchCaption */
        SearchCaption: {
            /**
             * Highlights
             * @default null
             */
            highlights: string | null;
            /**
             * Text
             * @default null
             */
            text: string | null;
        };
        /** SearchParameters */
        SearchParameters: {
            /** Minimum Reranker Score */
            minimum_reranker_score: number | null;
            /** Minimum Search Score */
            minimum_search_score: number | null;
            /** Top */
            top: number;
            /** Use Query Rewriting */
            use_query_rewriting: boolean;
            /** Use Semantic Captions */
            use_semantic_captions: boolean;
            /** Use Semantic Ranker */
            use_semantic_ranker: boolean;
            /** Use Text Search */
            use_text_search: boolean;
            /** Use Vector Search */
            use_vector_search: boolean;
        };
        /**
         * SearchResultDocument
         * @description A search index document as returned to the admin search page.
         */
        SearchResultDocument: {
            /** Captions */
            captions: components["schemas"]["SearchCaption"][];
            /**
             * Category
             * @default null
             */
            category: string | null;
            /**
             * Chapter
             * @default null
             */
            chapter: string | null;
            /**
             * Citationid
             * @default null
             */
            citationId: string | null;
            /**
             * Cloudinaryid
             * @default null
             */
            cloudinaryID: string | null;
            /**
             * Content
             * @default null
             */
            content: string | null;
            /**
             * Countries
             * @default null
             */
            countries: string[] | null;
            /**
             * Domain
             * @default null
             */
            domain: string | null;
            /**
             * Id
             * @default null
             */
            id: string | null;
            /**
             * Intellumdescription
             * @default null
             */
            intellumDescription: string | null;
            /**
             * Intellumorganization
             * @default null
             */
            intellumOrganization: string | null;
            /**
             * Intellumpresenters
             * @default null
             */
            intellumPresenters: string | null;
            /**
             * Intellumtranscriptid
             * @default null
             */
            intellumTranscriptId: string | null;
            /**
             * Intellumurl
             * @default null
             */
            intellumUrl: string | null;
            /**
             * Intellumvideourl
             * @default null
             */
            intellumVideoUrl: string | null;
            /**
             * Interestareas
             * @default null
             */
            interestAreas: string[] | null;
            /**
             * Ismergedchunk
             * @default false
             */
            isMergedChunk: boolean;
            /**
             * Knowledgebase Query
             * @default null
             */
            knowledgebase_query: string | null;
            /**
             * Language
             * @default null
             */
            language: string | null;
            /**
             * Languagevarianturls
             * @default null
             */
            languageVariantUrls: string[] | null;
            /**
             * Languagevariants
             * @default null
             */
            languageVariants: string[] | null;
            /**
             * Lastmodifiedtimestamp
             * @default null
             */
            lastModifiedTimestamp: string | null;
            /**
             * Mediatype
             * @default null
             */
            mediaType: string | null;
            /**
             * Publicationaiconsent
             * @default null
             */
            publicationAiConsent: boolean | null;
            /**
             * Publicationbodysite
             * @default null
             */
            publicationBodySite: string | null;
            /**
             * Publicationid
             * @default null
             */
            publicationId: string | null;
            /**
             * Publicationindications
             * @default null
             */
            publicationIndications: string[] | null;
            /**
             * Publicationjournal
             * @default null
             */
            publicationJournal: string | null;
            /**
             * Publicationjournalimpactfactor
             * @default null
             */
            publicationJournalImpactFactor: number | null;
            /**
             * Publicationjournalscimagojournalrank
             * @default null
             */
            publicationJournalSCImagoJournalRank: number | null;
            /**
             * Publicationjournalsourcenormalizedimpactperpaper
             * @default null
             */
            publicationJournalSourceNormalizedImpactperPaper: number | null;
            /**
             * Publicationproductgroups
             * @default null
             */
            publicationProductGroups: string[] | null;
            /**
             * Publicationpubmedabstract
             * @default null
             */
            publicationPubMedAbstract: string | null;
            /**
             * Publicationpubmedid
             * @default null
             */
            publicationPubMedId: string | null;
            /**
             * Publicationpublicationyear
             * @default null
             */
            publicationPublicationYear: string | null;
            /**
             * Publicationtechniques
             * @default null
             */
            publicationTechniques: string[] | null;
            /**
             * Publicationtype
             * @default null
             */
            publicationType: string | null;
            /**
             * Publicationurl
             * @default null
             */
            publicationUrl: string | null;
            /**
             * Pulicationauthors
             * @default null
             */
            pulicationAuthors: string | null;
            /**
             * Pulicationstudytype
             * @default null
             */
            pulicationStudyType: string | null;
            /**
             * Rankingtimestamp
             * @default null
             */
            rankingTimestamp: string | null;
            /**
             * Referencenumber
             * @default null
             */
            referenceNumber: string | null;
            /**
             * Relatedproductnumbers
             * @default null
             */
            relatedProductNumbers: string[] | null;
            /**
             * Relatedresourcereferencenumbers
             * @default null
             */
            relatedResourceReferenceNumbers: string[] | null;
            /**
             * Repappurl
             * @default null
             */
            repAppUrl: string | null;
            /**
             * Reranker Score
             * @default null
             */
            reranker_score: number | null;
            /**
             * Resourcetypes
             * @default null
             */
            resourceTypes: string[] | null;
            /**
             * Score
             * @default null
             */
            score: number | null;
            /**
             * Source
             * @default null
             */
            source: string | null;
            /**
             * Sourcefile
             * @default null
             */
            sourcefile: string | null;
            /**
             * Sourcepage
             * @default null
             */
            sourcepage: string | null;
            /**
             * Storageurl
             * @default null
             */
            storageUrl: string | null;
            /**
             * Thumbnailurl
             * @default null
             */
            thumbnailUrl: string | null;
            /**
             * Title
             * @default null
             */
            title: string | null;
        };
        /** Source */
        Source: {
            /**
             * Asseturl
             * @default null
             */
            assetUrl?: string | null;
            /**
             * Cloudinaryid
             * @default null
             */
            cloudinaryId?: string | null;
            /** Datasource */
            dataSource: string;
            /** Id */
            id: string;
            /**
             * Interestareas
             * @default null
             */
            interestAreas?: string[] | null;
            /**
             * Lastmodifiedon
             * @default null
             */
            lastModifiedOn?: string | null;
            /** Mediatype */
            mediaType: string;
            /**
             * Rankingtimestamp
             * @default null
             */
            rankingTimestamp?: string | null;
            /**
             * Referencenumber
             * @default null
             */
            referenceNumber?: string | null;
            /**
             * Rerankersearchscore
             * @default null
             */
            rerankerSearchScore?: number | null;
            /**
             * Resourcetype
             * @default null
             */
            resourceType?: string | null;
            /**
             * Searchscore
             * @default null
             */
            searchScore?: number | null;
            /**
             * Thumbnailurl
             * @default null
             */
            thumbnailUrl?: string | null;
            /** Title */
            title: string;
            /** Url */
            url: string;
        };
        /** @enum {string} */
        SpeechRate: "x-slow" | "slow" | "medium" | "fast" | "x-fast";
        /**
         * SpeechRequest
         * @description Body of POST /speech, which answers with MP3 audio. Documentation only: the
         *     route reads the fields itself.
         */
        SpeechRequest: {
            speechRate: components["schemas"]["SpeechRate"];
            /** Text */
            text: string;
        };
        /** SstResponse */
        SstResponse: {
            /** Sstrequestid */
            sstRequestId: string;
            /** Transcript */
            transcript: string;
        };
        /**
         * SttAudioDoneFrame
         * @description The recording is complete; the server answers with stt.result or stt.error.
         */
        SttAudioDoneFrame: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "stt.audio.done";
        };
        /** SttCancelFrame */
        SttCancelFrame: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "stt.cancel";
        };
        SttClientFrame: components["schemas"]["SttAudioDoneFrame"] | components["schemas"]["SttCancelFrame"];
        /** SttErrorFrame */
        SttErrorFrame: {
            /** Error */
            error: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "stt.error";
        };
        /** SttReadyFrame */
        SttReadyFrame: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "stt.ready";
        };
        /** SttResultFrame */
        SttResultFrame: {
            /** Sstrequestid */
            sstRequestId: string;
            /** Text */
            text: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "stt.result";
        };
        SttServerFrame: components["schemas"]["SttReadyFrame"] | components["schemas"]["SttResultFrame"] | components["schemas"]["SttErrorFrame"];
        /** Thought */
        Thought: {
            /**
             * Description
             * @default null
             */
            description?: string | null;
            /**
             * Props
             * @default null
             */
            props?: {
                [key: string]: unknown;
            } | null;
            /** Title */
            title: string;
        };
        /** TokenUsageProps */
        TokenUsageProps: {
            /**
             * Cached Input Tokens
             * @default null
             */
            cached_input_tokens?: number | null;
            /** Completion Tokens */
            completion_tokens: number;
            /** Prompt Tokens */
            prompt_tokens: number;
            /** Reasoning Tokens */
            reasoning_tokens: number | null;
            /** Total Tokens */
            total_tokens: number;
        };
        /** ToolCall */
        ToolCall: {
            /**
             * Arguments
             * @default null
             */
            arguments?: string | null;
            /** Id */
            id: string;
            /**
             * Results
             * @default null
             */
            results?: unknown | null;
            /** Status */
            status: string;
            /**
             * Statusvalue
             * @enum {string}
             */
            statusValue: "running" | "completed" | "failed";
            /**
             * Toolid
             * @default
             */
            toolId?: string;
            /** Toolname */
            toolName: string;
        };
        /** TouchpointAnalyticsDataPoint */
        TouchpointAnalyticsDataPoint: {
            /** Message Count */
            message_count: number;
            /** Percentage */
            percentage: number;
            /** Touchpoint */
            touchpoint: string;
            /** Unique Users */
            unique_users: number;
        };
        /** TouchpointAnalyticsResponseSchema */
        TouchpointAnalyticsResponseSchema: {
            /** Available Countries */
            available_countries: string[];
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /** Data */
            data: components["schemas"]["TouchpointAnalyticsDataPoint"][];
            /** End Date */
            end_date: string;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Total Messages */
            total_messages: number;
            /** Total Touchpoints */
            total_touchpoints: number;
        };
        /**
         * UpdateUserSettingsRequest
         * @description Body of the self-service and admin user-settings update routes.
         */
        UpdateUserSettingsRequest: {
            /** Settings */
            settings: {
                [key: string]: unknown;
            };
        };
        /** UserActivityAnalyticsResponseSchema */
        UserActivityAnalyticsResponseSchema: {
            /**
             * Available Countries
             * @default null
             */
            available_countries?: string[] | null;
            /**
             * Available Domains
             * @default null
             */
            available_domains?: string[] | null;
            /**
             * Available Touchpoints
             * @default null
             */
            available_touchpoints?: string[] | null;
            /** Data */
            data: components["schemas"]["UserActivityDataPoint"][];
            /** End Date */
            end_date: string;
            /**
             * Sql Query
             * @default null
             */
            sql_query?: string | null;
            /** Start Date */
            start_date: string;
            /** Top Users */
            top_users: number;
            /** Total Users */
            total_users: number;
        };
        /** UserActivityDataPoint */
        UserActivityDataPoint: {
            /** Average Messages */
            average_messages: number;
            /** Entra Oid */
            entra_oid: string;
            /** Name */
            name: string;
            /** Total Conversations */
            total_conversations: number;
            /** Total Messages */
            total_messages: number;
            /** Username */
            username: string;
        };
        /** UserActivityStats */
        UserActivityStats: {
            /** First Activity */
            first_activity: string | null;
            /** Last Activity */
            last_activity: string | null;
            /** Total Conversations */
            total_conversations: number;
            /** Total Messages */
            total_messages: number;
        };
        /** UserDetails */
        UserDetails: {
            activity_stats: components["schemas"]["UserActivityStats"];
            /** Entra Oid */
            entra_oid: string;
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Username */
            username: string;
        };
        /** UserFilter */
        UserFilter: {
            /** Assettypes */
            assetTypes?: string[];
            /** Interestareas */
            interestAreas?: string[];
        };
        /** UserList */
        UserList: {
            /** Page */
            page: number;
            /** Page Size */
            page_size: number;
            /** Total Items */
            total_items: number;
            /** Total Pages */
            total_pages: number;
            /** Users */
            users: components["schemas"]["UserListItem"][];
        };
        /** UserListItem */
        UserListItem: {
            /** Entra Oid */
            entra_oid: string;
            /** Name */
            name: string;
            /** Username */
            username: string;
        };
        /** UserSettingsDocument */
        UserSettingsDocument: {
            /** Entra Oid */
            entra_oid: string;
            /** Id */
            id: string;
            /** Name */
            name: string;
            /** Settings */
            settings: {
                [key: string]: unknown;
            };
            /** Usercountry */
            userCountry: string;
            /** Username */
            username: string;
        };
        /** UserSettingsResponse */
        UserSettingsResponse: {
            settings: components["schemas"]["UserSettingsDocument"];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type AdminChatHistoryItem = components["schemas"]["AdminChatHistoryItem"];
export type AdminChatHistoryTurn = components["schemas"]["AdminChatHistoryTurn"];
export type AppConfig = components["schemas"]["AppConfig"];
export type AssetTypeOption = components["schemas"]["AssetTypeOption"];
export type AuthSetup = components["schemas"]["AuthSetup"];
export type Authorization = components["schemas"]["Authorization"];
export type BuildInfo = components["schemas"]["BuildInfo"];
export type ChatFeedbackRequest = components["schemas"]["ChatFeedbackRequest"];
export type ChatHistory = components["schemas"]["ChatHistory"];
export type ChatHistoryItem = components["schemas"]["ChatHistoryItem"];
export type ChatHistoryItemDetails = components["schemas"]["ChatHistoryItemDetails"];
export type ChatHistoryRequest = components["schemas"]["ChatHistoryRequest"];
export type ChatHistoryTurn = components["schemas"]["ChatHistoryTurn"];
export type ChatMessageAnalyticsResponseSchema = components["schemas"]["ChatMessageAnalyticsResponseSchema"];
export type ChatMessageDataPoint = components["schemas"]["ChatMessageDataPoint"];
export type ChatRequest = components["schemas"]["ChatRequest"];
export type ConversationAnalyticsResponseSchema = components["schemas"]["ConversationAnalyticsResponseSchema"];
export type ConversationDataPoint = components["schemas"]["ConversationDataPoint"];
export type DatabricksTraceUrl = components["schemas"]["DatabricksTraceUrl"];
export type Delta = components["schemas"]["Delta"];
export type Domain = components["schemas"]["Domain"];
export type ErrorDetails = components["schemas"]["ErrorDetails"];
export type ExampleQuestion = components["schemas"]["ExampleQuestion"];
export type ExampleQuestions = components["schemas"]["ExampleQuestions"];
export type FailureType = components["schemas"]["FailureType"];
export type FeedbackAnalyticsResponseSchema = components["schemas"]["FeedbackAnalyticsResponseSchema"];
export type FeedbackDataPoint = components["schemas"]["FeedbackDataPoint"];
export type FeedbackItem = components["schemas"]["FeedbackItem"];
export type FeedbackList = components["schemas"]["FeedbackList"];
export type FeedbackListItem = components["schemas"]["FeedbackListItem"];
export type FeedbackReason = components["schemas"]["FeedbackReason"];
export type FilterOptions = components["schemas"]["FilterOptions"];
export type HistoryList = components["schemas"]["HistoryList"];
export type HistoryListItem = components["schemas"]["HistoryListItem"];
export type IdeaItem = components["schemas"]["IdeaItem"];
export type IdeaList = components["schemas"]["IdeaList"];
export type IdeaReviewStatus = components["schemas"]["IdeaReviewStatus"];
export type InterestAreaOption = components["schemas"]["InterestAreaOption"];
export type MsalAuthConfig = components["schemas"]["MsalAuthConfig"];
export type MsalCacheConfig = components["schemas"]["MsalCacheConfig"];
export type MsalConfig = components["schemas"]["MsalConfig"];
export type MsalRequest = components["schemas"]["MsalRequest"];
export type PatchFeedbackRequest = components["schemas"]["PatchFeedbackRequest"];
export type PatchIdeaRequest = components["schemas"]["PatchIdeaRequest"];
export type PeakHoursAnalyticsResponseSchema = components["schemas"]["PeakHoursAnalyticsResponseSchema"];
export type PeakHoursDataPoint = components["schemas"]["PeakHoursDataPoint"];
export type SearchAdminRequest = components["schemas"]["SearchAdminRequest"];
export type SearchAdminResponse = components["schemas"]["SearchAdminResponse"];
export type SearchCaption = components["schemas"]["SearchCaption"];
export type SearchParameters = components["schemas"]["SearchParameters"];
export type SearchResultDocument = components["schemas"]["SearchResultDocument"];
export type Source = components["schemas"]["Source"];
export type SpeechRate = components["schemas"]["SpeechRate"];
export type SpeechRequest = components["schemas"]["SpeechRequest"];
export type SstResponse = components["schemas"]["SstResponse"];
export type SttAudioDoneFrame = components["schemas"]["SttAudioDoneFrame"];
export type SttCancelFrame = components["schemas"]["SttCancelFrame"];
export type SttClientFrame = components["schemas"]["SttClientFrame"];
export type SttErrorFrame = components["schemas"]["SttErrorFrame"];
export type SttReadyFrame = components["schemas"]["SttReadyFrame"];
export type SttResultFrame = components["schemas"]["SttResultFrame"];
export type SttServerFrame = components["schemas"]["SttServerFrame"];
export type Thought = components["schemas"]["Thought"];
export type TokenUsageProps = components["schemas"]["TokenUsageProps"];
export type ToolCall = components["schemas"]["ToolCall"];
export type TouchpointAnalyticsDataPoint = components["schemas"]["TouchpointAnalyticsDataPoint"];
export type TouchpointAnalyticsResponseSchema = components["schemas"]["TouchpointAnalyticsResponseSchema"];
export type UpdateUserSettingsRequest = components["schemas"]["UpdateUserSettingsRequest"];
export type UserActivityAnalyticsResponseSchema = components["schemas"]["UserActivityAnalyticsResponseSchema"];
export type UserActivityDataPoint = components["schemas"]["UserActivityDataPoint"];
export type UserActivityStats = components["schemas"]["UserActivityStats"];
export type UserDetails = components["schemas"]["UserDetails"];
export type UserFilter = components["schemas"]["UserFilter"];
export type UserList = components["schemas"]["UserList"];
export type UserListItem = components["schemas"]["UserListItem"];
export type UserSettingsDocument = components["schemas"]["UserSettingsDocument"];
export type UserSettingsResponse = components["schemas"]["UserSettingsResponse"];
export type $defs = Record<string, never>;
export interface operations {
    post_admin_ai_search: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SearchAdminRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SearchAdminResponse"];
                };
            };
        };
    };
    get_get_chat_messages_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                aggregation?: "day" | "week" | "month" | "year";
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatMessageAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_get_conversations_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                aggregation?: "day" | "week" | "month" | "year";
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConversationAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_get_feedback_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                aggregation?: "day" | "week" | "month" | "year";
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeedbackAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_get_peak_hours_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                aggregation?: "day" | "week" | "month" | "year";
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PeakHoursAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_get_touchpoint_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                aggregation?: "day" | "week" | "month" | "year";
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TouchpointAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_get_user_activity_analytics: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                countries?: string | null;
                domains?: string | null;
                touchpoints?: string | null;
                entra_oid?: string | null;
                top_users?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserActivityAnalyticsResponseSchema"];
                };
            };
        };
    };
    get_auth_setup: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description MSAL.js settings for the client app. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthSetup"];
                };
            };
        };
    };
    get_get_authorization: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Authorization"];
                };
            };
        };
    };
    get_config: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AppConfig"];
                };
            };
        };
    };
    get_content_file: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                path: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_export_feedback: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
                user_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_get_feedback_item: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                feedback_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single feedback document, with its conversation snapshot sanitized. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeedbackItem"];
                };
            };
        };
    };
    delete_delete_feedback_item: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                feedback_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    patch_patch_feedback_item: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                feedback_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PatchFeedbackRequest"];
            };
        };
        responses: {
            /** @description A single feedback document, with its conversation snapshot sanitized. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeedbackItem"];
                };
            };
        };
    };
    get_get_feedback: {
        parameters: {
            query?: {
                page_size?: number;
                page?: number;
                sort_by?: string;
                sort_dir?: string;
                search?: string;
                user_id?: string;
                review_status?: "" | "reviewed" | "not_reviewed";
                failure_types?: string[];
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeedbackList"];
                };
            };
        };
    };
    get_export_history: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
                user_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_get_chat_history_item_admin: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A conversation as the admin history viewer sees it. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminChatHistoryItem"];
                };
            };
        };
    };
    delete_delete_history_item_admin: {
        parameters: {
            query?: {
                entra_oid?: string;
            };
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_get_history_item_databricks_trace_url: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                item_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DatabricksTraceUrl"];
                };
            };
        };
    };
    get_get_history: {
        parameters: {
            query?: {
                page_size?: number;
                page?: number;
                sort_by?: string;
                sort_dir?: string;
                search?: string;
                user_id?: string;
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HistoryList"];
                };
            };
        };
    };
    get_export_ideas: {
        parameters: {
            query?: {
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
                user_id?: string;
                review_status?: "" | "new" | "reviewed" | "cancelled";
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_get_idea: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                idea_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description An idea as the admin UI sees it, in the list and in the detail view. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IdeaItem"];
                };
            };
        };
    };
    patch_patch_idea: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                idea_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PatchIdeaRequest"];
            };
        };
        responses: {
            /** @description An idea as the admin UI sees it, in the list and in the detail view. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IdeaItem"];
                };
            };
        };
    };
    get_get_ideas: {
        parameters: {
            query?: {
                page_size?: number;
                page?: number;
                sort_by?: string;
                sort_dir?: string;
                search?: string;
                user_id?: string;
                category_filter?: string;
                include_drafts?: boolean;
                review_status?: "" | "new" | "reviewed" | "cancelled";
                start_date?: string | null;
                end_date?: string | null;
                timezone?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["IdeaList"];
                };
            };
        };
    };
    post_speech: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SpeechRequest"];
            };
        };
        responses: never;
    };
    get_export_users: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    get_get_users_list: {
        parameters: {
            query?: {
                page_size?: number;
                page?: number;
                sort_by?: string;
                sort_dir?: string;
                search?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserList"];
                };
            };
        };
    };
    get_get_user_details: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserDetails"];
                };
            };
        };
    };
    put_update_user_settings_admin: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateUserSettingsRequest"];
            };
        };
        responses: never;
    };
    get_get_user_settings: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserSettingsResponse"];
                };
            };
        };
    };
    post_update_user_settings: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateUserSettingsRequest"];
            };
        };
        responses: never;
    };
    post_v2_chat_feedback: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                conversation_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ChatFeedbackRequest"];
            };
        };
        responses: never;
    };
    post_v2_chat_history_list: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ChatHistoryRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatHistory"];
                };
            };
        };
    };
    post_v2_chat_history_detail: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                conversation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ChatHistoryItemDetails"];
                };
            };
        };
    };
    delete_v2_delete_chat_history: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                conversation_id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: never;
    };
    post_v2_chat_stream: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ChatRequest"];
            };
        };
        responses: {
            /** @description NDJSON stream: one Delta per line. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json-lines": components["schemas"]["Delta"];
                };
            };
        };
    };
    get_v2_user_filter_options: {
        parameters: {
            query?: {
                domain?: components["schemas"]["Domain"] | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FilterOptions"];
                };
            };
        };
    };
    get_v2_example_questions: {
        parameters: {
            query?: {
                domain?: components["schemas"]["Domain"] | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExampleQuestions"];
                };
            };
        };
    };
    post_sst_transcribe: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SstResponse"];
                };
            };
        };
    };
    get_version: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BuildInfo"];
                };
            };
        };
    };
}
type FlattenedDeepRequired<T> = {
    [K in keyof T]-?: FlattenedDeepRequired<T[K] extends unknown[] | undefined | null ? Extract<T[K], unknown[]>[number] : T[K]>;
};
type ReadonlyArray<T> = [Exclude<T, undefined>] extends [unknown[]] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const pathsAnalyticsChatMessagesGetParametersQueryAggregationValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/analytics/chat-messages"]["get"]["parameters"]["query"]["aggregation"]
> = ["day", "week", "month", "year"];
export const pathsAnalyticsConversationsGetParametersQueryAggregationValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/analytics/conversations"]["get"]["parameters"]["query"]["aggregation"]
> = ["day", "week", "month", "year"];
export const pathsAnalyticsFeedbackGetParametersQueryAggregationValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/analytics/feedback"]["get"]["parameters"]["query"]["aggregation"]
> = ["day", "week", "month", "year"];
export const pathsAnalyticsPeakHoursGetParametersQueryAggregationValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/analytics/peak-hours"]["get"]["parameters"]["query"]["aggregation"]
> = ["day", "week", "month", "year"];
export const pathsAnalyticsTouchpointsGetParametersQueryAggregationValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/analytics/touchpoints"]["get"]["parameters"]["query"]["aggregation"]
> = ["day", "week", "month", "year"];
export const pathsFeedbacklistGetParametersQueryReview_statusValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/feedbacklist"]["get"]["parameters"]["query"]["review_status"]
> = ["", "reviewed", "not_reviewed"];
export const pathsIdeaExportGetParametersQueryReview_statusValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/idea/export"]["get"]["parameters"]["query"]["review_status"]
> = ["", "new", "reviewed", "cancelled"];
export const pathsIdealistGetParametersQueryReview_statusValues: ReadonlyArray<
    FlattenedDeepRequired<paths>["/idealist"]["get"]["parameters"]["query"]["review_status"]
> = ["", "new", "reviewed", "cancelled"];
export const domainValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Domain"]> = ["human", "vet"];
export const errorDetailsCodeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ErrorDetails"]["code"]> = [
    "rate_limit",
    "content_filter",
    "content_length",
    "generic"
];
export const failureTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FailureType"]> = [
    "Hallucination",
    "Incorrect answer",
    "Incomplete answer",
    "No answer",
    "Question issue",
    "Technical issue",
    "Policy issue",
    "Source issue",
    "Other"
];
export const feedbackListItemFeedback_typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FeedbackListItem"]["feedback_type"]> = [
    "like",
    "dislike"
];
export const feedbackReasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FeedbackReason"]> = [
    "incorrect_answer",
    "incomplete_answer",
    "unsuitable_asset"
];
export const ideaItemStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["IdeaItem"]["status"]> = ["draft", "confirmed"];
export const ideaReviewStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["IdeaReviewStatus"]> = ["new", "reviewed", "cancelled"];
export const speechRateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SpeechRate"]> = ["x-slow", "slow", "medium", "fast", "x-fast"];
export const sttAudioDoneFrameTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SttAudioDoneFrame"]["type"]> = ["stt.audio.done"];
export const sttCancelFrameTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SttCancelFrame"]["type"]> = ["stt.cancel"];
export const sttErrorFrameTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SttErrorFrame"]["type"]> = ["stt.error"];
export const sttReadyFrameTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SttReadyFrame"]["type"]> = ["stt.ready"];
export const sttResultFrameTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SttResultFrame"]["type"]> = ["stt.result"];
export const toolCallStatusValueValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ToolCall"]["statusValue"]> = [
    "running",
    "completed",
    "failed"
];
